
const initHeader = () => {
    const bodyElm = document.querySelector('body');
    if (!bodyElm) return;

    /* ========================= Backdrop utils ========================= */
    const createBackdrop = (afterSelectorOrEl, onClick, className = 'backdrop') => {
        const classes = className.split(' ').filter(Boolean); // массив классов

        // Проверяем, существует ли backdrop хоть с одним из классов
        let existing = classes.map(cls => '.' + cls).join(',');
        let found = document.querySelector(existing);
        if (found) return found;

        const container = (typeof afterSelectorOrEl === 'string')
            ? document.querySelector(afterSelectorOrEl)
            : afterSelectorOrEl;

        if (!container) return null;

        const backdrop = document.createElement('div');

        // Добавляем все классы
        classes.forEach(cls => backdrop.classList.add(cls));

        // show всегда добавляется
        backdrop.classList.add('show');

        container.after(backdrop);

        return backdrop;
    };

    const removeBackdrop = (className = 'backdrop') => {
        const el = document.querySelector('.' + className);
        // console.log('el to remove', el);
        if (el) el.remove();
    };

    /* ========================= Menu ========================= */
    const closeMenu = () => {
        if (bodyElm.classList.contains('menu--open')) {
            bodyElm.classList.remove('menu--open', 'overflow--hidden');
            bodyElm.style.paddingRight = '0';
            removeBackdrop('backdrop');
            // removeBackdrop('submenu-backdrop');
            // closeAllSubmenus();
        }
    };

    const toggleMenu = () => {
        const isOpen = bodyElm.classList.contains('menu--open');

        if (isOpen) {
            closeMenu();
        } else {
            bodyElm.classList.add('menu--open', 'overflow--hidden');
            bodyElm.style.paddingRight = window.innerWidth - bodyElm.clientWidth + 'px';
            createBackdrop('.header__overlay_wrapper', closeMenu, 'backdrop');
        }
    };

    const initMenuToggle = () => {
        document.addEventListener('click', (e) => {
            if (e.target.closest('[data-menu-trigger]')) {
                e.preventDefault();
                e.stopPropagation();
                toggleMenu();
            }

            if (e.target.closest('[data-menu-close]')) {
                e.preventDefault();
                closeMenu();
                setTimeout(() => {
                    closeCatalog();
                }, 100);
            }

            if (e.target.closest('.backdrop')) {
                e.preventDefault();
                closeMenu();
                setTimeout(() => {
                    closeCatalog();
                }, 100);
            }
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1280) {
                closeMenu();
            }
        });
    };

    /* ========================= Search ========================= */
    const closeSearch = () => {
        if (bodyElm.classList.contains('search--open')) {
            bodyElm.classList.remove('search--open', 'overflow--hidden');
            bodyElm.style.paddingRight = '0';
            removeBackdrop('backdrop');
        }
    };

    const toggleSearch = () => {
        const isOpen = bodyElm.classList.contains('search--open');
        if (isOpen) {
            closeSearch();
        } else {
            closeMenu();

            bodyElm.classList.add('search--open', 'overflow--hidden');
            bodyElm.style.paddingRight = window.innerWidth - bodyElm.clientWidth + 'px';
            createBackdrop('.header', closeSearch, 'backdrop');
        }
    };

    const initSearchToggle = () => {
        document.addEventListener('click', (e) => {
            if (e.target.closest('[data-search-trigger]')) {
                e.preventDefault();
                e.stopPropagation();
                toggleSearch();
            }

            if (e.target.closest('[data-search-close]')) {
                e.preventDefault();
                closeSearch();
            }

            if (e.target.closest('.backdrop')) {
                e.preventDefault();
                closeSearch();
            }
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1280) {
                closeSearch();
            }
        });
    };

    /* ========================= Sticky header on scroll ========================= */
    const initHeaderScrollBehavior = () => {
        const headerStickyElm = document.querySelector('.header--sticky');
        // const headerTop = document.querySelector('.header__top');
        if (!headerStickyElm) return;

        // const threshold = headerTop.offsetHeight;

        let lastScrollY = window.scrollY;
        let lastScrollYLast = window.scrollY;


        window.addEventListener('scroll', () => {
            // headerSticky.classList.toggle('header__scroll', window.scrollY > threshold);

            lastScrollY = window.scrollY;
            // headerStickyElmHeight = headerStickyElm.offsetHeight;
            // langElm.classList.remove('open');

            if (lastScrollY > lastScrollYLast) {
                // console.log('down')
                headerStickyElm.classList.remove('header--pin');
                if (lastScrollY > 0) {
                    headerStickyElm.classList.add('header--scroll');
                    // headerStickyElm.classList.remove('header__pin');

                    // bodyElm.classList.remove('menu--open', 'search--open', 'catalog--open', 'overflow--hidden');
                    // bodyElm.style.paddingRight = '0';
                    // document.querySelector('.backdrop').remove();
                    // hideBackdropBlock();
                }
            } else {
                // console.log('up')
                headerStickyElm.classList.add('header--pin');

                if (lastScrollY <= 10) {
                    headerStickyElm.classList.remove('header--scroll');
                    // headerStickyElm.classList.remove('header__pin');
                }
                if (lastScrollY <= 1) {
                    headerStickyElm.classList.remove('header--pin');
                    // headerStickyElm.classList.remove('header__pin');
                }
            }
            lastScrollYLast = lastScrollY;

        });
    };

    /* ========================= Language dropdown ========================= */
    // const toggleLang = () => {
    //     bodyElm.classList.toggle('lang--open');
    // };
    //
    // const closeLang = () => {
    //     bodyElm.classList.remove('lang--open');
    // };
    //
    // const initLangToggle = () => {
    //     const langTrigger = document.querySelector('[data-lang-trigger]');
    //     if (!langTrigger) return;
    //
    //     document.addEventListener('click', (e) => {
    //         if (e.target.closest('[data-lang-trigger]')) {
    //             e.preventDefault();
    //             e.stopPropagation();
    //             toggleLang();
    //         } else if (!e.target.closest('.header__lang')) {
    //             closeLang();
    //         }
    //     });
    // };

    /* ========================= Catalog (no paddingRight / no overflow hidden) ========================= */
    const closeCatalog = () => {
        if (!bodyElm.classList.contains('catalog--open')) return;

        bodyElm.classList.remove('catalog--open');
        document.querySelectorAll('[data-catalog-list]').forEach(list => {
            list.classList.remove('show');
        });

        removeBackdrop('catalog-backdrop');
    };

    const toggleCatalog = (name, triggerBtn) => {

        const isOpen = bodyElm.classList.contains('catalog--open');
        const shownLists = Array.from(document.querySelectorAll('[data-catalog-list].show'));
        const sameOpen = isOpen && shownLists.length > 0 && shownLists.every(el => el.getAttribute('data-catalog-list') === name);

        if (sameOpen) {
            closeCatalog();
            return;
        }

        bodyElm.classList.add('catalog--open');

        document.querySelectorAll('[data-catalog-list]').forEach(list => {
            if (list.getAttribute('data-catalog-list') === name) {
                list.classList.add('show');
            } else {
                list.classList.remove('show');
            }
        });


        createBackdrop('.header', closeCatalog, 'backdrop catalog-backdrop');

        // const container =
        //     (triggerBtn && triggerBtn.closest('.header__catalog')) ||
        //     document.querySelector('.header__catalog') ||
        //     document.body;
        //
        // createBackdrop(container, closeCatalog, 'catalog-backdrop');
    };

    const initCatalogToggle = () => {
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-catalog-toggle]');
            if (btn) {
                e.preventDefault();
                e.stopPropagation();
                toggleCatalog(btn.getAttribute('data-catalog-toggle'), btn);
                return;
            }

            if (e.target.closest('[data-catalog-back]')) {
                e.preventDefault();
                closeCatalog();
                return;
            }

            if (e.target.closest('.catalog-backdrop')) {
                e.preventDefault();
                closeCatalog();
            }
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1280) {
                closeCatalog();
            }
        });
    };

    /* ========================= Init all ========================= */
    initMenuToggle();
    initSearchToggle();
    initHeaderScrollBehavior();
    // initLangToggle();
    initCatalogToggle();
};

export default initHeader;
